var _excluded = ["htmlFor", "error", "disabled", "className", "children"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import * as React from 'react';
import { styled } from '@creditas-ui/system';
import { Box } from '@creditas-ui/layout';
import { ifProp, selectTheme, getTypography } from '@creditas-ui/utilities';
var LabelElement = styled(Box.withComponent('label', process.env.NODE_ENV === "production" ? {
  target: "e1ypjrmk0"
} : {
  target: "e1ypjrmk0",
  label: "LabelElement"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n"])), getTypography('bodyMdRegular'), ifProp('disabled', selectTheme('input.placeholder.disabled.color'), ifProp('error', selectTheme('input.placeholder.error.color'), selectTheme('input.placeholder.color'))));
var InputLabel = _ref => {
  var {
      htmlFor = '',
      error,
      disabled,
      className,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LabelElement, _extends({}, props, {
    className: className,
    htmlFor: htmlFor,
    error: error,
    disabled: disabled
  }), children);
};
export { InputLabel };
//# sourceMappingURL=InputLabel.js.map